export default "__VITE_ASSET__z$pau6Do__";